import * as React from 'react';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import { enabledLanguages, LANGUAGE_LABELS } from '../../utils/languages';

/**
 * Exclusive language toggle over the languages the app supports (Finnish, English, Swedish).
 * `onChange` receives `(event, newValue)` like a plain MUI ToggleButtonGroup; the current
 * value is always offered even when it is outside the enabled set.
 */
export default function LanguageToggle({ value, onChange, size, sx }) {
  const languages = enabledLanguages(value);

  return (
    <ToggleButtonGroup value={value} exclusive onChange={onChange} size={size} sx={sx}>
      {languages.map((code) => (
        <ToggleButton key={code} value={code}>
          {LANGUAGE_LABELS[code] ?? code}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
